import React from 'react';

import {
  Box,
  Button,
  styled
} from '@mui/material';
import {
  BaseModal,
  Form
} from 'iron-forge-react-modules';



const ChildBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3)
}));



export interface IProps {
  title: string;
  isDoubleWide?: boolean;
  children: React.ReactNode | React.ReactNode[];
  isLoading?: boolean;

  onClose: () => void;
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;

  fnGenElCloseButton?: (args: BaseModal.IFnGenElCloseButtonArgs) => JSX.Element;
  fnGenElAcceptButton?: (args: BaseModal.IFnGenElAcceptButtonArgs) => JSX.Element;
}

export const FC: React.FC<IProps> = props => {
  React.useEffect(() => {
    const listener = function (ev: KeyboardEvent) {
      if (ev.key === 'Escape' && !props.isLoading) {
        props.onClose();
      }
    };

    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, [props]);

  return (
    <BaseModal.FC
      isDoubleWide={props.isDoubleWide}
      title={props.title}
      isOpen
      onClose={props.onClose}
      showButtons
      fnGenElCloseButton={props.fnGenElCloseButton}
      fnGenElAcceptButton={props.fnGenElAcceptButton ?? (() => (
        <Button
          type="submit"
          variant="contained">
          Save
        </Button>
      ))}
    >
      {args => (
        <Form.FC
          disableDefaultOverflow
          onSubmit={props.onSubmit ?? (async () => { })}>
          <ChildBox>
            {props.children}
          </ChildBox>

          {args.buttons}
        </Form.FC>
      )}
    </BaseModal.FC>
  );
};
